// src/components/StepperDialog.tsx

import React, { useEffect, useState } from 'react';
import {
    Dialog, AppBar, Toolbar, IconButton, Typography, Stepper, Step, StepLabel,
    Button, TextField, Container, Box, Select, SelectChangeEvent,
    Menu,
    MenuItem,
    InputLabel
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Step1AnswerQuestions } from './Step1AnswerQuestions';
import { ContractViewer, Step2ContractViewer } from './Step2ContractViewer';
import { useLocation, useNavigate } from 'react-router-dom';
import { MemberCreateStage1Data } from '../../interfaces/User.interface';
import { useFetch } from '../../utils/FetchTemplate';
import { useLoading } from '../../contexts/LoadingContext';
import { useAuth } from '../../contexts/AuthContext';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const steps = ['Answer Questions', 'Sign Contract', 'Confirm Information'];

const StepperDialog = () => {
    const email = useQuery().get('email') as string;
    const checkoutSessionId = useQuery().get('session') as string;
    const { postData, getData } = useFetch()

    const navigate = useNavigate();
    // if email or plans not exists, then redirect to 404
    const [activeStep, setActiveStep] = useState(0);
    const [step1Data, setStep1Data] = useState<any>({email, checkoutSessionId});
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleFinish = () => {
        setActiveStep(0);
    };


    useEffect(() => {
        // use fetch to check if the user is valid
        const url = process.env.REACT_APP_BACKEND_URL + `/api/member/session/validate/${checkoutSessionId}`;
        getData(url).then(()=>{
            if (!email || !checkoutSessionId) {
                navigate('/not-found');
            }
        }).catch(() => {
            navigate('/not-found');
        }).finally(() =>{
        });

    }, [email, checkoutSessionId])

    const stage1Data: MemberCreateStage1Data  = {
        email: email,
    }

    return (
        <Dialog fullScreen open={true}>
            <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" aria-label="close">
                        <CloseIcon />
                    </IconButton>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                        Stepper Dialog
                    </Typography>
                </Toolbar>
            </AppBar>
            <Container>
                <Stepper activeStep={activeStep} sx={{ pt: 3, pb: 5 }}>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                {/* Step 0 */}
                {activeStep === 0 && (
                    <Step1AnswerQuestions handleNext={handleNext} prevData={stage1Data} setStep1Data={setStep1Data}/>
                )}
                {/* Step 1 */}
                {activeStep === 1 && (
                    <Step2ContractViewer handleNext={handleNext} url="http://192.168.1.25:13000/sample.pdf" prevData={step1Data}></Step2ContractViewer>
                )}
                {/* Step 2 */}
                {activeStep === 2 && (
                    <Box sx={{ mt: 1 }}>
                        <h1> To Be Updated</h1>
                    </Box>
                )}
            </Container>
        </Dialog>
    );
};

export default StepperDialog;
